import React, { useContext, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { AccessLevel, LawPortalFeature, Module, OrganizationFeature, UserContext } from '../../../../../Context/UserContext/UserContext';
import { Button, Grid, makeStyles } from '@material-ui/core';
import { CompanyUnitSelectDialog } from './../../../../../Components';
import { EditLegalListWizard } from '../EditLegalListWizard';
import { UpdateConnectionWizardDialog } from '../UpdateConnectionWizard';

const useStyles = makeStyles(() => ({
  topActionContainer: {
    marginBottom: '1rem',
    display: 'flex',
  },
}));

interface ICustomerLawListActionsProps {
  onDeleteComplete?: () => void;
}

export const CustomerLawListActions = ({ onDeleteComplete }: ICustomerLawListActionsProps) => {
  const { hasAccessToFeature,hasAccessToModule, getCompanyUnitName } = useContext(UserContext);
  const canManage = hasAccessToModule(Module.Organization) && hasAccessToFeature(OrganizationFeature.Manage, AccessLevel.Administer)
  const accessToOurLaws = hasAccessToFeature(LawPortalFeature.Manage, AccessLevel.Manage);
  const [updateDialogOpen, setUpdateDialogOpen] = useState<boolean>(false);
  const [editLegalListDialogOpen, setEditLegalListDialogOpen] = useState<boolean>(false);
  const [connectionWizardOpen, setConnectionWizardOpen] = useState<boolean>(false);
  const { formatMessage } = useIntl();
  const classes = useStyles();

  const openMassUpdate = () => setUpdateDialogOpen(true);
  const closeMassUpdate = () => setUpdateDialogOpen(false);

  const openEditLegalList = () => {
    setEditLegalListDialogOpen(true);
  };

  const openConnectionWizard = () => {
    setConnectionWizardOpen(true);
  };

  const handleEditComplete = () => {
    if (onDeleteComplete) {
      onDeleteComplete();
    }
  };

  const handleConnectionWizardComplete = () => {
    if (onDeleteComplete) {
      onDeleteComplete();
    }
  };

  if (!accessToOurLaws) {
    return null;
  }

  return (
    <>
      <Grid container justify="flex-end" className={classes.topActionContainer} spacing={1} direction="row">
        {/* <Grid item>
          <Button onClick={openMassUpdate} variant="outlined">
            <FormattedMessage id="law-portal.manage.law-list.update-laws" />
          </Button>
          <CompanyUnitSelectDialog
            urlTemplate="/law-portal/our-laws/update-for-company-unit/{id}"
            title={formatMessage({ id: 'law-portal.manage.law-list.update-laws' })}
            selectPlaceholder={formatMessage(
              { id: 'law-portal.manage.update-laws.dialog.companyUnit.placeholder' },
              { alias: getCompanyUnitName(formatMessage, true) },
            )}
            open={updateDialogOpen}
            close={closeMassUpdate}
          />
        </Grid> */}
        <Grid item>
          <Button onClick={openConnectionWizard} variant="outlined">
            <FormattedMessage id="law-portal.manage.law-list.update-laws" />
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={openEditLegalList} variant="outlined">
            <FormattedMessage id="law-portal.manage.legal-list.editLegalList" defaultMessage="Edit legislation" />
          </Button>
        </Grid>
      </Grid>
      <EditLegalListWizard
        open={editLegalListDialogOpen}
        onClose={() => setEditLegalListDialogOpen(false)}
        onComplete={handleEditComplete}
      />
      <UpdateConnectionWizardDialog
        open={connectionWizardOpen}
        onClose={() => setConnectionWizardOpen(false)}
        onComplete={handleConnectionWizardComplete}
      />
    </>
  );
};
